import { surveyFormsService } from "../../../Api/Services/SurveyFormsService";
import { SLICE_NAMES, ACTION_NAMES } from "../../../constants/action";
import { ERROR_MESSAGES } from "../../../constants/error";
import createGenericSlice from "../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../utils/reduxUtils/createServiceAsyncThunk";

export const changeStatusSurveyFormQuestion = createServiceAsyncThunk<
  { status: boolean; message: string },
  { question_id: number; status: number }
>(
  ACTION_NAMES.CHANGE_STATUS_SURVEY_QUESTION,
  (payload) => surveyFormsService.updateFormQuestionStatus(payload),
  ERROR_MESSAGES.CHANGE_STATUS_SURVEY_QUESTION_FAILURE
);

const changeStatusSurveyQuestionSlice = createGenericSlice<
  { status: boolean; message: string },
  { question_id: number; status: number }
>(
  SLICE_NAMES.CHANGE_STATUS_SURVEY_QUESTION_SLICE,
  changeStatusSurveyFormQuestion
);

export const {
  clearError: clearDeleteSurveyQuestionError,
  clearSuccessMessage: clearDeleteSurveyQuestionSuccess,
} = changeStatusSurveyQuestionSlice.actions;

export default changeStatusSurveyQuestionSlice.reducer;
